<app-modal-header [hasClose]='true' [title]="title" (handleClose)="close()"></app-modal-header>

<mat-dialog-content class="content-dialog">

  <form [formGroup]="applicationProfileForm" #formDirective="ngForm">
    <div class="options">
      <div class="form-pattern flex">
        <mat-form-field appearance="outline" class="half-input">
          <mat-label>{{ loading ? 'Carregando...' : 'Aplicação' }}</mat-label>
          <mat-select matSelect formControlName="event_id" placeholder="{{ loading ? 'Carregando...' : 'Aplicação' }}" required>
            @for (application of applicationsArray; track application) {
              <mat-option [value]="application.id">
                {{application.description}}
              </mat-option>
            }
          </mat-select>
          @if (applicationProfileForm.get('event_id').errors && applicationProfileForm.get('event_id').touched) {
            <mat-error>
            {{applicationProfileForm.get('event_id').errors['message']}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-input">
          <mat-label>Perfis de Acesso</mat-label>
          <mat-select matSelect formControlName="access_profile_id" placeholder="Perfis de Acesso" (selectionChange)="verifyRequeriments()" required>
            @for (profile of profileArray; track profile) {
              <mat-option [value]="profile.invite_profile_id">
                {{profile.description}}
              </mat-option>
            }
          </mat-select>
          @if (applicationProfileForm.get('access_profile_id').errors && applicationProfileForm.get('access_profile_id').touched) {
            <mat-error>
            {{applicationProfileForm.get('access_profile_id').errors['message']}}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-pattern flex">
        @if (showSchools) {
          <mat-form-field appearance="outline">
            <mat-label>Escola</mat-label>
            <mat-select matSelect formControlName="school_id" placeholder="Escola" [disabled]="!showSchools" required (selectionChange)="filterCourse($event)">
              @for (school of schoolArray; track school) {
                <mat-option [value]="school.id">
                  {{school.description}}
                </mat-option>
              }
            </mat-select>
            @if (applicationProfileForm.get('school_id').errors && applicationProfileForm.get('school_id').touched) {
              <mat-error>
              {{applicationProfileForm.get('school_id').errors['message']}}</mat-error>
            }
          </mat-form-field>
        }

      </div>
      <div class="form-pattern flex">
        @if (showCourses) {
          <mat-form-field appearance="outline">
            <mat-label>Curso</mat-label>
            <mat-select matSelect formControlName="course_id" placeholder="Curso" [disabled]="applicationProfileForm.get('school_id').invalid">
              @for (course of coursesArray; track course) {
                <mat-option [value]="course.id">
                  {{course.description}}
                </mat-option>
              }
            </mat-select>
            @if (applicationProfileForm.get('course_id').errors && applicationProfileForm.get('course_id').touched) {
              <mat-error>
              {{applicationProfileForm.get('course_id').errors['message']}}</mat-error>
            }
          </mat-form-field>
        }
      </div>

    </div>
  </form>

</mat-dialog-content>

<div class="modal-footer">
  <button id="modalApplyBtn" type="button" mat-raised-button [disabled]="applicationProfileForm.invalid" (click)="onApply()">
    Aplicar Perfil
  </button>
  <!-- <button type="button" mat-raised-button class="cancel-btn" (click)="close()">
  Cancelar
</button> -->
</div>
